module.exports = __webpack_public_path__ + "img/header-navigation-below-infiniti.140a5f5a.png";